import React from 'react';
import { motion } from 'framer-motion';

interface KeyProps {
  value: string;
  displayValue?: string;
  onPress: (key: string) => void;
  className?: string;
  disabled?: boolean;
}

export const Key: React.FC<KeyProps> = ({ 
  value, 
  displayValue, 
  onPress, 
  className = "", 
  disabled = false 
}) => {
  const handlePress = () => {
    if (!disabled) {
      onPress(value);
    }
  };

  return (
    <motion.button
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.05 }}
      onClick={handlePress}
      disabled={disabled}
      className={`
        bg-white border border-gray-300 rounded-lg
        text-gray-800 font-medium text-sm md:text-base
        shadow-lg hover:bg-gray-100 hover:shadow-xl
        transition-all duration-200 ease-out
        active:bg-gray-200
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {displayValue || value}
    </motion.button>
  );
};